import { createContext, useContext } from "react";
import type { PermissionKey, SessionUser } from "@grizzly/shared";

export type SessionStatus = "loading" | "authenticated" | "anonymous";

export interface SessionState {
  status: SessionStatus;
  user: SessionUser | null;
  login(email: string, password: string): Promise<void>;
  logout(): Promise<void>;
}

export const SessionContext = createContext<SessionState | null>(null);

export function useSession(): SessionState {
  const ctx = useContext(SessionContext);
  if (!ctx) throw new Error("useSession must be used inside SessionProvider");
  return ctx;
}

export function useHasPermission(permission: PermissionKey): boolean {
  const { user } = useSession();
  return !!user && user.permissions.includes(permission);
}
